import config from "../../../../packages/config"
import { Link } from "../../../../packages/ui/link"

export const frontmatter = {
  title: "Terms and Conditions",
  date: "2026-04-03",
}

### 1. Agreement to Terms

By accessing or using {config.core.projectName}, you agree to be bound by these Terms and Conditions, our [Privacy Policy](/legal/privacy), and our [Licenses](/legal/licenses). If you do not agree to these terms, please do not use our services.

### 2. Description of Service

{config.core.projectName} is an open-source, Cloudflare-based web application stack engineered for tiny, fast-moving teams. It provides a production-ready codebase with integrated authentication, database, email, and deployment infrastructure, licensed under the MIT License.

For detailed licensing terms, see our [Licenses](/legal/licenses) page.

### 3. User Accounts

To access certain features, you may be required to create an account. You are responsible for:

- Maintaining the confidentiality of your account credentials
- All activities that occur under your account
- Notifying us immediately of any unauthorized use of your account

### 4. Payments and Refunds

Certain products or services offered through {config.core.projectName} may require payment. By completing a purchase, you agree to:

- Pay the applicable fee as displayed at the time of purchase
- Provide accurate and complete billing information

Refunds are handled on a case-by-case basis. If you are not satisfied with your purchase, please contact us at <Link href={`mailto:${config.core.supportEmail}`}>{config.core.supportEmail}</Link> within 14 days of purchase to discuss your options.

### 5. Third-Party Services

{config.core.projectName} integrates with third-party services including but not limited to:

- **Cloudflare** — Hosting, Workers, D1 database, and Turnstile bot protection
- **Polar.sh** — Payment processing
- **Resend** — Transactional email delivery

Your use of these services is subject to their respective terms of service and privacy policies. {config.core.projectName} is not responsible for the availability, functionality, or policies of third-party services.

### 6. Acceptable Use

You agree not to use {config.core.projectName} to:

- Violate any applicable laws or regulations
- Infringe upon the intellectual property rights of others
- Distribute malware, viruses, or other harmful code
- Build applications that facilitate illegal activities
- Misrepresent {config.core.projectName} as your own original creation

### 7. Intellectual Property

The {config.core.projectName} brand, logo, documentation, and marketing materials are owned by {config.core.projectName} and are protected by intellectual property laws.

Applications you build using {config.core.projectName} belong to you. You retain full ownership of your projects, including any modifications or extensions you make to the codebase.

### 8. Disclaimer of Warranties

{config.core.projectName} is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not warrant that:

- The codebase will be error-free or bug-free
- The service will be uninterrupted
- The codebase will meet your specific requirements without modification
- Third-party integrations will remain compatible indefinitely

### 9. Limitation of Liability

To the maximum extent permitted by law, {config.core.projectName} and its affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or in connection with your use of the service, including but not limited to loss of profits, data, business opportunities, or revenue.

### 10. Support

{config.core.projectName} provides documentation and community resources to help you use the product. While we strive to be helpful, we do not guarantee response times or resolution of specific issues. For support inquiries, contact us at <Link href={`mailto:${config.core.supportEmail}`}>{config.core.supportEmail}</Link>.

### 11. Changes to Terms

We reserve the right to modify these terms at any time. We will notify users of material changes by posting the updated terms on <Link href={config.core.websiteUrl}>{config.core.websiteUrl}</Link>. Your continued use of {config.core.projectName} after such changes constitutes acceptance of the new terms.

### 12. Governing Law

These Terms and Conditions shall be governed by and construed in accordance with the laws of Australia, without regard to its conflict of law provisions.

### 13. Contact Us

If you have any questions about these Terms and Conditions, please contact us at <Link href={`mailto:${config.core.supportEmail}`}>{config.core.supportEmail}</Link>.
